<template>
  <v-sheet
    :width="size"
    :height="size"
    :color="`rgba( 0, 0, 0, ${opacity} )`"
    rounded
    class="rating-circle d-flex rounded-pill align-center"
  >
    <v-progress-circular :value="rating * 10" :rotate="-90" :size="size" :width="strokeWidth" dark color="white">
      <v-icon dark :size="size - 8">{{ getRatingIcon }}</v-icon>
    </v-progress-circular>
  </v-sheet>
</template>

<style scoped>
.d-flex {
  justify-content: center;
}

.v-progress-circular {
  flex: 1;
}

.v-progress-circular >>> .v-progress-circular__underlay {
  stroke: rgba(255, 255, 255, 0.25);
}
</style>

<script>
export default {
  name: "rating-circle-monochrome",

  props: {
    rating: { type: Number, default: 0 },

    size: { type: Number, default: 64 },

    opacity: { type: Number, default: 0.9 },
  },

  computed: {
    strokeWidth: function () {
      return this.size * 0.075;
    },

    getRatingIcon: function () {
      // TODO: Allow decimals
      return `mdi-numeric-${this.rating}`;
    },
  },

  data: () => ({}),
};
</script>
